module.exports = __webpack_public_path__ + "static/media/slider-2.b5fcde0b.jpg";